const TELIA_SOFI_CATEGORY_LINK_SELECTOR = ".humany-category-link";

function showAllCategoriesOnOpenedCategoryClick(e: Event) {
  const allCategoriesButton = document.querySelector<HTMLAnchorElement>(`[data-guide-category="0"] .humany-category-link`);
  if (!allCategoriesButton) {
    return;
  }
  e.preventDefault();
  e.stopPropagation();
  allCategoriesButton.click();
}

document.addEventListener("click", (e: Event) => {
  const target = e.target;
  if (!target) {
    return;
  }
  const categoryLink = (target as HTMLElement).closest(TELIA_SOFI_CATEGORY_LINK_SELECTOR);
  if (!categoryLink) {
    return;
  }
  const isOpen = categoryLink.closest("li.humany-expanded") !== null;
  if (!isOpen) {
    return;
  }
  showAllCategoriesOnOpenedCategoryClick(e);
});

function addDatasetDebugHintToCategoryLinks() {
  const callback = () => {
    const teliaLinks = document.querySelectorAll<HTMLAnchorElement>(TELIA_SOFI_CATEGORY_LINK_SELECTOR);
    if (!teliaLinks.length) {
      return;
    }
    // debug search help: data-js-sas-modified
    teliaLinks.forEach((link) => (link.dataset.jsSasModified = "1"));
  };
  const observer = new MutationObserver(callback);
  observer.observe(document.body, { attributes: false, childList: true, subtree: true });
}
addDatasetDebugHintToCategoryLinks();
